import React from 'react';

import styles from './AgentsBox.module.scss';

export const AgentsBox = () => (
  <div className={styles.agentsBox}>
    <span className={styles.avatar} />
    <span className={styles.avatar} />
    <span className={styles.avatar} />
  </div>
);
